import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import AuthPage from "./hoc/AuthPage";

const NoAccountPage = () => {
  return (
    <AuthPage>
      <p className="mb-5 lead">Don't worry we will handle that at the end.</p>
      <Button as={Link} to="/new-order" size="lg" block>
        Start Your Order
      </Button>
    </AuthPage>
  );
};

export default NoAccountPage;
